export const TYPE_TRACKER_SUBMIT = 'tracker_submit';
export const FIELD_TYPE_SELECT = 'select';
export const FIELD_TYPE_LINKS_LIST = 'links_list';
